import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferSubmitPayload } from 'api/actions/price-offer-submit/price-offer-submit-payload';
import { PriceOfferSubmitPathParameters } from 'api/actions/price-offer-submit/price-offer-submit-path-parameters';
import { PriceOfferSubmitResponse } from 'api/actions/price-offer-submit/price-offer-submit-response';

type PriceOfferSubmitQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferSubmit action.
 */
export const priceOfferSubmitActionPath = new SweetPath<keyof PriceOfferSubmitPathParameters>(
  '/api/price-offer/submit/{priceOfferId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferSubmit actions.
 */
export default function createPriceOfferSubmitAction(axios: AxiosInstance) {
  return function priceOfferSubmitAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PriceOfferSubmitPathParameters;
    query?: PriceOfferSubmitQueryParameters;
    payload: PriceOfferSubmitPayload;
  }) {
    const path = priceOfferSubmitActionPath.insert(parameters);

    return axios.request<PriceOfferSubmitResponse, PriceOfferSubmitResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
